namespace Eruda {
  export function init() {};
}

export default Eruda;
